import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-first',
  templateUrl: './mobile-first.component.html',
  styleUrls: ['./mobile-first.component.scss']
})
export class MobileFirstComponent {

}
